import React, { Component } from 'react'
import { string, func, any, object, oneOfType, array } from 'prop-types'

export default class Radio extends Component {
  render () {
    const { name, selectedValue, onChange } = this.context.radioGroup
    const optional = {}
    if (selectedValue !== undefined) {
      optional.checked = (this.props.value === selectedValue)
    }
    if (typeof onChange === 'function') {
      optional.onChange = () => onChange(this.props.value)
    }

    // Children null beceause input must not contain any child
    return (
      <div className='form__input__radio'>
        <input
          {...this.props}
          children={null}
          type='radio'
          name={name}
          className='form__input'
          {...optional}
          id={`${name}${this.props.value}`} />
        <label className='form__input__radio__label' htmlFor={`${name}${this.props.value}`}>
          {this.props.children}
        </label>
      </div>
    )
  }
}

Radio.propTypes = {
  value: any,
  children: oneOfType([
    string,
    func,
    object,
    array
  ])
}

Radio.contextTypes = {
  name: string,
  radioGroup: object,
  onChange: func,
  selectedValue: any
}



// WEBPACK FOOTER //
// ./src/components/ui/inputs/Radio.js